<template>
  <v-dialog v-model="dialog" :max-width="options.width" :style="{ zIndex: options.zIndex }" @keydown.esc="cancel">
    <v-card>
      <v-toolbar color="transparent" flat>
        <v-toolbar-title>
          {{ title }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <slot name="body" />
      </v-card-text>
      <v-card-actions>
        <v-btn color="grey" outlined text @click.native="cancel">Cancel</v-btn>
        <v-spacer />
        <v-btn :disabled="!valid" :color="options.color" @click.native="agree">
          {{ action }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    valid: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    title: null,
    action: null,
    options: {
      color: 'primary',
      width: 350,
      zIndex: 200,
      controlled: false,
      extraData: null,
    },
  }),
  methods: {
    /** @public */
    open(title, action, options) {
      this.dialog = true;
      this.title = title;
      this.action = action;

      if (options) {
        this.options = Object.assign(this.options, options);
      }

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      if (this.options.controlled) {
        this.$emit('agree', this.options.extraData);
      } else {
        this.resolve(true);
        this.dialog = false;
      }
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>
